import * as React from 'react';
import AspectRatio from '@mui/joy/AspectRatio';
import Card from '@mui/joy/Card';
import CardActions from '@mui/joy/CardActions';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import { SvgIconProps } from '@mui/material/SvgIcon';

interface AboutCardProps {
  icon: React.ComponentType<SvgIconProps>;
  title: string;
  content: string;
  shareButtonText: string;
  skipButtonText: string;
  iconColor?: string;
}

const AboutCard: React.FC<AboutCardProps> = ({ 
  icon: Icon, 
  title, 
  content, 
  shareButtonText, 
  skipButtonText, 
  iconColor = 'inherit' 
}) => {
  return (
    <Card
      className="m-auto "
      sx={{
        textAlign: 'center',
        alignItems: 'center',
        // width: 343,
        overflow: 'auto',
        '--icon-size': '100px',

      }}
    >
      <AspectRatio
        variant="plain"
        ratio="1"
        sx={{
          m: 'auto',
          width: 'var(--icon-size)',
          position: 'relative',
        }}
      >
        <div>
          <Icon sx={{ fontSize: '4rem', color: iconColor }} />
        </div>
      </AspectRatio>
      <Typography level="title-lg" sx={{ }}>
        {title}
      </Typography>
      <CardContent sx={{ maxWidth: '40ch', textAlign:'justify' }}>
        {content}
      </CardContent>
      <CardActions
        orientation="vertical"
        buttonFlex={1}
        sx={{
          '--Button-radius': '40px',
          width: 'clamp(min(100%, 160px), 50%, min(100%, 200px))',
        }}
      >
      </CardActions>
    </Card>
  );
};

export default AboutCard;
